// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/creator/site/v1/site.proto (package fingertip.creator.site.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { BoolValue, proto3, StringValue } from "@bufbuild/protobuf";
import { Site } from "../../../common/type/v1/site_pb.js";
import { Location } from "../../../common/type/v1/location_pb.js";
import { RelevanceMap } from "../../../common/type/v1/relevance_map_pb.js";
import { SiteStatus } from "../../../common/enum/v1/site_status_pb.js";
import { SitePurpose } from "../../../common/enum/v1/site_purpose_pb.js";
import { Media, MediaValue } from "../../../common/type/v1/media_pb.js";
import { SocialIcon } from "../../../common/type/v1/social_icon_pb.js";
import { PageInfo } from "../../../common/type/v1/page_info_pb.js";
import { Block } from "../../../common/type/v1/block_pb.js";

/**
 * @generated from message fingertip.creator.site.v1.GetSiteRequest
 */
export const GetSiteRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site.v1.GetSiteRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "site_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.site.v1.GetSiteResponse
 */
export const GetSiteResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site.v1.GetSiteResponse",
  () => [
    { no: 1, name: "site", kind: "message", T: Site },
    { no: 2, name: "location", kind: "message", T: Location },
  ],
);

/**
 * @generated from message fingertip.creator.site.v1.GetSiteRelevanceMapRequest
 */
export const GetSiteRelevanceMapRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site.v1.GetSiteRelevanceMapRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.site.v1.GetSiteRelevanceMapResponse
 */
export const GetSiteRelevanceMapResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site.v1.GetSiteRelevanceMapResponse",
  () => [
    { no: 1, name: "relevance_map", kind: "message", T: RelevanceMap },
  ],
);

/**
 * @generated from message fingertip.creator.site.v1.CreateSiteRequest
 */
export const CreateSiteRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site.v1.CreateSiteRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "qr_code_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "onboarding_google_place_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "business_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "google_place_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "status", kind: "enum", T: proto3.getEnumType(SiteStatus) },
    { no: 11, name: "google_location", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "conversion_metadata", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "site_template_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "tag_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 19, name: "time_zone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 22, name: "onboarding_step", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 30, name: "ip", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 31, name: "ip_country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 32, name: "ip_region", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 33, name: "ip_city", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 34, name: "ip_continent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 35, name: "ip_postal_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 36, name: "ip_metro_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 37, name: "ip_is_eu_country", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 38, name: "ip_region_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 39, name: "ip_latitude", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 40, name: "ip_longitude", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 41, name: "ip_timezone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 42, name: "site_template_tag_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 43, name: "purpose", kind: "enum", T: proto3.getEnumType(SitePurpose) },
    { no: 44, name: "selected_site_template_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 45, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 46, name: "sensitive_content", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 47, name: "workspace_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 48, name: "logo_media", kind: "message", T: Media },
    { no: 49, name: "social_icons", kind: "message", T: SocialIcon, repeated: true },
    { no: 50, name: "default_locale", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 51, name: "facebook_pixel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 52, name: "google_analytics_tracking_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 53, name: "google_tag_manager_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.site.v1.CreateSiteResponse
 */
export const CreateSiteResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site.v1.CreateSiteResponse",
  () => [
    { no: 1, name: "site", kind: "message", T: Site },
  ],
);

/**
 * @generated from message fingertip.creator.site.v1.UpdateSiteRequest
 */
export const UpdateSiteRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site.v1.UpdateSiteRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "new_site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "business_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "google_place_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "status", kind: "enum", T: proto3.getEnumType(SiteStatus) },
    { no: 11, name: "google_location", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "is_white_labeled", kind: "message", T: BoolValue },
    { no: 13, name: "google_analytics_tracking_id", kind: "message", T: StringValue },
    { no: 14, name: "facebook_pixel_id", kind: "message", T: StringValue },
    { no: 15, name: "favicon_bucket", kind: "message", T: StringValue },
    { no: 16, name: "onboarding_google_place_id", kind: "message", T: StringValue },
    { no: 21, name: "home_page_id", kind: "message", T: StringValue },
    { no: 22, name: "time_zone", kind: "message", T: StringValue },
    { no: 25, name: "onboarding_step", kind: "message", T: StringValue },
    { no: 29, name: "site_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 30, name: "ip", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 31, name: "ip_country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 32, name: "ip_region", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 33, name: "ip_city", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 34, name: "ip_continent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 35, name: "ip_postal_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 36, name: "ip_metro_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 37, name: "ip_is_eu_country", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 38, name: "ip_region_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 39, name: "ip_latitude", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 40, name: "ip_longitude", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 41, name: "ip_timezone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 42, name: "site_template_tag_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 43, name: "purpose", kind: "enum", T: proto3.getEnumType(SitePurpose) },
    { no: 44, name: "selected_site_template_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 45, name: "description", kind: "message", T: StringValue },
    { no: 46, name: "google_tag_manager_id", kind: "message", T: StringValue },
    { no: 47, name: "sensitive_content", kind: "message", T: BoolValue },
    { no: 48, name: "workspace_slug", kind: "message", T: StringValue },
    { no: 50, name: "google_site_verification", kind: "message", T: StringValue },
    { no: 51, name: "logo_media", kind: "message", T: MediaValue },
    { no: 52, name: "social_icons", kind: "message", T: SocialIcon, repeated: true },
    { no: 53, name: "password_enabled", kind: "message", T: BoolValue },
    { no: 54, name: "password", kind: "message", T: StringValue },
    { no: 55, name: "default_locale", kind: "message", T: StringValue },
  ],
);

/**
 * @generated from message fingertip.creator.site.v1.UpdateSiteResponse
 */
export const UpdateSiteResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site.v1.UpdateSiteResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "new_site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.site.v1.GetSitesRequest
 */
export const GetSitesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site.v1.GetSitesRequest",
  () => [
    { no: 1, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "statuses", kind: "enum", T: proto3.getEnumType(SiteStatus), repeated: true },
    { no: 5, name: "workspace_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "ignore_admin_view", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "is_site_template", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "is_pro", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.site.v1.GetSitesResponse
 */
export const GetSitesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site.v1.GetSitesResponse",
  () => [
    { no: 1, name: "sites", kind: "message", T: Site, repeated: true },
    { no: 2, name: "total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_info", kind: "message", T: PageInfo },
  ],
);

/**
 * @generated from message fingertip.creator.site.v1.DeleteSiteRequest
 */
export const DeleteSiteRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site.v1.DeleteSiteRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.site.v1.DeleteSiteResponse
 */
export const DeleteSiteResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site.v1.DeleteSiteResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.site.v1.ClaimSiteRequest
 */
export const ClaimSiteRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site.v1.ClaimSiteRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "conversion_metadata", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.site.v1.ClaimSiteResponse
 */
export const ClaimSiteResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site.v1.ClaimSiteResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.site.v1.GetSiteSlugRequest
 */
export const GetSiteSlugRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site.v1.GetSiteSlugRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.site.v1.GetSiteSlugResponse
 */
export const GetSiteSlugResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site.v1.GetSiteSlugResponse",
  () => [
    { no: 1, name: "already_taken", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * no-op
 *
 * @generated from message fingertip.creator.site.v1.GetSitesAdminRequest
 */
export const GetSitesAdminRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site.v1.GetSitesAdminRequest",
  [],
);

/**
 * @generated from message fingertip.creator.site.v1.GetSitesAdminResponse
 */
export const GetSitesAdminResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site.v1.GetSitesAdminResponse",
  () => [
    { no: 1, name: "sites", kind: "message", T: Site, repeated: true },
    { no: 2, name: "total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message fingertip.creator.site.v1.DuplicateSiteRequest
 */
export const DuplicateSiteRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site.v1.DuplicateSiteRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "new_site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.site.v1.DuplicateSiteResponse
 */
export const DuplicateSiteResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site.v1.DuplicateSiteResponse",
  () => [
    { no: 1, name: "new_site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.site.v1.MigrateSiteRequest
 */
export const MigrateSiteRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site.v1.MigrateSiteRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.site.v1.MigrateSiteResponse
 */
export const MigrateSiteResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site.v1.MigrateSiteResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.site.v1.OnboardingBlock
 */
export const OnboardingBlock = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site.v1.OnboardingBlock",
  () => [
    { no: 1, name: "block", kind: "message", T: Block },
    { no: 2, name: "is_checked", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "relevance", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "explanation", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.site.v1.GetSiteProgressRequest
 */
export const GetSiteProgressRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site.v1.GetSiteProgressRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.site.v1.GetSiteProgressResponse
 */
export const GetSiteProgressResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site.v1.GetSiteProgressResponse",
  () => [
    { no: 1, name: "page_completed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "bookings_completed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "forms_completed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "invoices_completed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "products_completed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "blog_completed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.site.v1.VerifySitePasswordRequest
 */
export const VerifySitePasswordRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site.v1.VerifySitePasswordRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.site.v1.VerifySitePasswordResponse
 */
export const VerifySitePasswordResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site.v1.VerifySitePasswordResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.site.v1.MigrateHeyLinkRequest
 */
export const MigrateHeyLinkRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site.v1.MigrateHeyLinkRequest",
  () => [
    { no: 1, name: "json", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "uuid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.site.v1.MigrateHeyLinkResponse
 */
export const MigrateHeyLinkResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site.v1.MigrateHeyLinkResponse",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

